import React from "react";

function Menu() {
  return (
    <div>
      <div className="home-menu-parent" id="menu">
        <div className="container">
          <div className="home-menu-header">
            <p className="sub-title">Enjoy home made food from our menu</p>
            <h2 className="title">Our Specialist</h2>
          </div>

          <div className="row">
            <div className="col-12 col-md-4 col-lg-4">
              <div className="menu-card-hover">
                <img
                  src="./assets/images/tiffins_menus/1.chowmeinwithrice.png"
                  className="card-img-top"
                />
                <p className="menu-card-price">Rs. 120</p>
                <div className="menu-card-title">
                  <h5 className="menu-card-item-title">
                    1. Manchurian with Chowmien
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-4">
              <div className="menu-card-hover">
                <img
                  src="./assets/images/tiffins_menus/3.Manchurian with fryrice..png"
                  className="card-img-top"
                />
                <p className="menu-card-price">Rs. 120</p>
                <div className="menu-card-title">
                  <h5 className="menu-card-item-title">
                    2. Manchurian with fryrice
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-4">
              <div className="menu-card-hover">
                <img
                  src="./assets/images/tiffins_menus/5.Roti with manchurian.png"
                  className="card-img-top"
                />
                <p className="menu-card-price">Rs. 120</p>
                <div className="menu-card-title">
                  <h5 className="menu-card-item-title">
                    3.Manchurian With Roti
                  </h5>
                </div>
              </div>
            </div>
          </div>

          <div className="row my-5">
            <div className="col-12 col-md-4 col-lg-4">
              <div className="menu-card-hover">
                <img
                  src="./assets/images/tiffins_menus/4.Chowmien with fryrice.png"
                  className="card-img-top"
                />
                <p className="menu-card-price">Rs. 120</p>
                <div className="menu-card-title">
                  <h5 className="menu-card-item-title">
                    4.Chowmien with fryrice
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-4">
              <div className="menu-card-hover">
                <img
                  src="./assets/images/tiffins_menus/2.Plainrice with veg curry.png"
                  className="card-img-top"
                />
                <p className="menu-card-price">Rs. 120</p>
                <div className="menu-card-title">
                  <h5 className="menu-card-item-title">
                    5. Plainrice with veg curry
                  </h5>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-4 col-lg-4">
              <div className="menu-card-hover">
                <img
                  src="./assets/images/tiffins_menus/6.Fryrice with veg curry.png"
                  className="card-img-top"
                />
                <p className="menu-card-price">Rs. 120</p>
                <div className="menu-card-title">
                  <h5 className="menu-card-item-title">
                    6.Fryrice with veg curry.
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="breakfast-menu container">
        <div className="row no-gutters">
          <div className="col">
            <div className="my-5">
              <p className="sub-title text-center">Fresh homemade foods</p>
              <h5 className="title text-center">MENU</h5>
            </div>

            <h5 className="ml-3 m-md-0 m-lg-0 p-0 mini-menu">BASIC DISH</h5>
            <div className="row no-gutters">
              <div className="col-12 col-md-6 col-lg-6 no-gutters">
                <ul className="list-group py-3 mx-3 mx-md-0 mx-lg-0">
                  <li className="list-item-group">
                    <span className="list-item-group-start">
                      <p className="list-item-group-title">
                        1. Piroaalu with chiura
                      </p>
                      <p className="list-item-group-sub-title">
                        PiroAalu with chiura
                      </p>
                    </span>
                    <p className="list-item-group-end">Rs 120.00</p>
                  </li>
                  <li className="list-item-group">
                    <span className="list-item-group-start">
                      <p className="list-item-group-title">2. Chatpate</p>
                      <p className="list-item-group-sub-title">Chatpate</p>
                    </span>
                    <p className="list-item-group-end">Rs 60.00</p>
                  </li>
                  <li className="list-item-group">
                    <span className="list-item-group-start">
                      <p className="list-item-group-title">3. Panipuri</p>
                      <p className="list-item-group-sub-title">Panipuri</p>
                    </span>
                    <p className="list-item-group-end">Rs 60.00</p>
                  </li>
                  <li className="list-item-group">
                    <span className="list-item-group-start">
                      <p className="list-item-group-title">4. French Fry</p>
                      <p className="list-item-group-sub-title">French Fry</p>
                    </span>
                    <p className="list-item-group-end">Rs 120.00</p>
                  </li>
                </ul>
              </div>
              <div className="col-12 col-md-6 col-lg-6 no-gutter">
                <ul className="list-group py-3 mx-3">
                  <li className="list-item-group">
                    <span className="list-item-group-start">
                      <p className="list-item-group-title">5. Chowmein</p>
                      <p className="list-item-group-sub-title">Chowmein</p>
                    </span>
                    <p className="list-item-group-end">Rs 100.00</p>
                  </li>
                  <li className="list-item-group">
                    <span className="list-item-group-start">
                      <p className="list-item-group-title">6. Fry Rice</p>
                      <p className="list-item-group-sub-title">Fry Rice</p>
                    </span>
                    <p className="list-item-group-end">Rs 100.00</p>
                  </li>
                  <li className="list-item-group">
                    <span className="list-item-group-start">
                      <p className="list-item-group-title">7. Manchurian</p>
                      <p className="list-item-group-sub-title">Manchurian</p>
                    </span>
                    <p className="list-item-group-end">Rs 120.00</p>
                  </li>
                </ul>
              </div>
            </div>

            <h5 className="ml-3 m-md-0 m-lg-0 p-0 mini-menu">SPECIAL DISH</h5>
            <div className="row no-gutters">
              <div className="col-12 col-md-6 col-lg-6 no-gutters">
                <ul className="list-group py-3 mx-3 mx-md-0 mx-lg-0">
                  <li className="list-item-group">
                    <span className="list-item-group-start">
                      <p className="list-item-group-title">
                        1. MANCHURIAN WITH CHOWMIEN
                      </p>
                      <p className="list-item-group-sub-title">
                        Machurian with veg chowmein
                      </p>
                    </span>
                    <p className="list-item-group-end">Rs 120.00</p>
                  </li>
                  <li className="list-item-group">
                    <span className="list-item-group-start">
                      <p className="list-item-group-title">
                        2. MANCHURIAN WITH FRYRICE
                      </p>
                      <p className="list-item-group-sub-title">
                        Manchurian with Fryrice
                      </p>
                    </span>
                    <p className="list-item-group-end">Rs 120.00</p>
                  </li>
                  <li className="list-item-group">
                    <span className="list-item-group-start">
                      <p className="list-item-group-title">
                        3. MANCHURIAN WITH ROTI
                      </p>
                      <p className="list-item-group-sub-title">
                        Manchurian with Roti
                      </p>
                    </span>
                    <p className="list-item-group-end">Rs 120.00</p>
                  </li>
                  <li className="list-item-group">
                    <span className="list-item-group-start">
                      <p className="list-item-group-title">
                        4. CHOWMIEN WITH FRYRICE
                      </p>
                      <p className="list-item-group-sub-title">
                        Special Chowmien with Fryrice
                      </p>
                    </span>
                    <p className="list-item-group-end">Rs 120.00</p>
                  </li>
                </ul>
              </div>
              <div className="col-12 col-md-6 col-lg-6 no-gutter">
                <ul className="list-group py-3 mx-3">
                  <li className="list-item-group">
                    <span className="list-item-group-start">
                      <p className="list-item-group-title">
                        5. Plainrice with veg curry
                      </p>
                      <p className="list-item-group-sub-title">
                        Plain rice with veg curry
                      </p>
                    </span>
                    <p className="list-item-group-end">Rs 120.00</p>
                  </li>
                  <li className="list-item-group">
                    <span className="list-item-group-start">
                      <p className="list-item-group-title">
                        6. FRYRICE WITH VEG CURRY
                      </p>
                      <p className="list-item-group-sub-title">
                        Fry Rice with veg curry
                      </p>
                    </span>
                    <p className="list-item-group-end">Rs 120.00</p>
                  </li>
                  <li className="list-item-group">
                    <span className="list-item-group-start">
                      <p className="list-item-group-title">
                        7. ROTI WITH VEG CURRY
                      </p>
                      <p className="list-item-group-sub-title">
                        Special Roti with veg curry
                      </p>
                    </span>
                    <p className="list-item-group-end">Rs 120.00</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Menu;
